import _ from 'lodash'
import { Environment, ModesDefinitions } from './types'
import type { BeckyModel } from '@wix/thunderbolt-becky-root'
import { parseSvgString } from '@wix/thunderbolt-commons'

export function buildEnvironment(beckyModel: BeckyModel): Environment {
	const { structure, clientSpecMap, shapeStore, compIdToPathToSelector } = beckyModel
	const environment: Environment = _.omit(beckyModel, ['structure', 'data'])

	environment.clientSpecMap = _(clientSpecMap).filter('appDefinitionId').keyBy('appDefinitionId').value()
	environment.mobile = {
		isMobileView: beckyModel.viewMode === 'mobile',
		isNonAdaptiveMobile:
			!beckyModel.isResponsive && beckyModel.deviceType === 'Smartphone' && beckyModel.viewMode === 'desktop',
		deviceType: beckyModel.deviceType,
	}
	environment.QA = {
		fullNameCompType: _.mapValues(structure, (comp) => comp.componentType),
	}
	environment.svgStore = { parsedSvg: _.mapValues(shapeStore, parseSvgString) }
	environment.modes = Object.values(structure).reduce<ModesDefinitions>((acc, comp) => {
		comp.modes?.definitions?.forEach((definition) => {
			acc[definition.modeId] = {
				prefix: definition.type === 'DEFAULT' ? '[data-mode=default]' : '[data-mode=hover]',
			}
		})
		return acc
	}, {})

	environment.compIdToPathToSelector = compIdToPathToSelector

	return environment
}
